<template>
  <div>
    <ProductHeader title="Nuevo Producto"/>
    <hr>
    <ProductForm :product="product" @onCreate="onCreate"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ProductHeader from '../ProductHeader'
import ProductForm from '../ProductForm'

export default {
  name: 'ProductNew',
  components: { ProductHeader, ProductForm },
  data () {
    return {
      product: {
        name: '',
        description: '',
        quantity: '',
        provenance: '',
        type: 'carbon'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleProductBtnLoading'
    ]),
    ...mapActions([
      'createProduct',
      'setAlertData',
      'isProductBtnLoading'
    ]),
    onCreate (data) {
      this.toggleProductBtnLoading(true)
      data.createdAt = new Date().getTime()
      this.createProduct(data)
        .then((res) => {
          this.toggleProductBtnLoading(false)
          this.$router.push({ name: 'Products' })
          this.setAlertData({
            visible: true,
            msg: 'Producto Creado ;)',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleProductBtnLoading(false)
          console.log('[onCreateProduct]')
          console.log(err.toString())
        })
    }
  }
}
</script>
